import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { setGlossaryContractorWrite, unassignGlossaries } from "../../../redux/ducks/glossary";
import AssignGlossary from "../../smart/buttonPopups/AssignGlossary";
import CreateGlossary from "../../smart/buttonPopups/CreateGlossary";
import { Table } from "../DataTable";

const Glossaries = props => {

    const glossaryURL = props.glossaryURL ? props.glossaryURL : "/PM/glossary/view/:glossaryID";
    const [checkValues, setCheckValues] = useState([]);
    const dispatch = useDispatch();

    const renderRow = (row, renderData) =>
        <React.Fragment>
            {renderData(row.ID, { key: "id" })}
            {renderData(row.name, { key: "name", here: glossaryURL.replace(":glossaryID", row.ID) })}
            {renderData(row.desc, { key: "desc" })}
            {renderData(row.sourceLang, { key: "sourcelang" })}
            {(props.titleID || props.projectID) ? renderData(row.contractorWrite, { key: "contractorWrite" }) : ""}
        </React.Fragment>

    let titleContent = <React.Fragment>
        <CreateGlossary />
    </React.Fragment>

    if (props.titleID != undefined) titleContent = <React.Fragment>
        <AssignGlossary titleID={props.titleID} />
        <button className={"button " + (checkValues.length == 0 ? "button--disabled" : "")} onClick={() => dispatch(unassignGlossaries({ glossaryIDs: checkValues, titleID: props.titleID }))}>UNASSIGN</button>
        <button className={"button button--primary " + (checkValues.length <= 0 ? "button--disabled" : "")} onClick={() => {
            const write = parseInt(prompt("Enter contractor write:"));

            if (write === 0 || write === 1) {
                dispatch(setGlossaryContractorWrite({ contractorWrite: write, glossaryIDs: checkValues, titleID: props.titleID }));
            }
        }}>Contractor write</button>
    </React.Fragment >

    if (props.projectID != undefined) titleContent = <React.Fragment>
        <AssignGlossary projectID={props.projectID} />
        <button className={"button " + (checkValues.length == 0 ? "button--disabled" : "")} onClick={() => dispatch(unassignGlossaries({ glossaryIDs: checkValues, projectID: props.projectID }))}>UNASSIGN</button>
        <button className={"button button--primary " + (checkValues.length <= 0 ? "button--disabled" : "")} onClick={() => {
            const write = parseInt(prompt("Enter contractor write:"));

            if (write === 0 || write === 1) {
                dispatch(setGlossaryContractorWrite({ contractorWrite: write, glossaryIDs: checkValues, projectID: props.projectID }));
            }
        }}>Contractor write</button>
    </React.Fragment>

    if (props.titleContent) titleContent = props.titleContent;

    return (
        <Table checkbox={true} newCheckValues={setCheckValues} getCheckValue={row => row.ID} title={"Glossaries"} titleContent={titleContent} renderRow={renderRow} rows={props.rows} cols={[{ name: "id", sortCol: "ID" }, { name: "name", sortCol: "name" }, { name: "desc", sortCol: "desc" }, { name: "source", sortCol: "sourceLang" }, { name: "contractor write", sortCol: "contractorWrite", hidden: !props.titleID && !props.projectID }]} />
    )

}

export default Glossaries;